import { defineMessages } from 'react-intl';

export const FirmwareMessages = defineMessages({
  firmware: {
    id: 'Firmware.firmware',
    defaultMessage: 'Firmware',
  },
  createFirmware: {
    id: 'Firmware.createFirmware',
    defaultMessage: 'Create Firmware',
  },
  editFirmware: {
    id: 'Firmware.editFirmware',
    defaultMessage: 'Edit Firmware',
  },
  binFile: {
    id: 'Firmware.binFile',
    defaultMessage: 'Bin File',
  },
  displayName: {
    id: 'Firmware.displayName',
    defaultMessage: 'Display Name',
  },
  displayNamePlaceholder: {
    id: 'Firmware.displayNamePlaceholder',
    defaultMessage: 'Add a name...',
  },
  fwVersion: {
    id: 'Firmware.fwVersion',
    defaultMessage: 'FW Version',
  },
  fwVersionPlaceholder: {
    id: 'Firmware.fwVersionPlaceholder',
    defaultMessage: 'Add a version...',
  },
  deploymentType: {
    id: 'Firmware.deploymentType',
    defaultMessage: 'Deployment Type',
  },
  archiveFirmware: {
    id: 'Firmware.archiveFirmware',
    defaultMessage: 'Archive Firmware',
  },
  archiveFirmwarePlaceholder: {
    id: 'Firmware.archiveFirmwarePlaceholder',
    defaultMessage: 'Select an archive status...',
  },
  notArchived: {
    id: 'Firmware.notArchived',
    defaultMessage: 'Not Archived',
  },
  upload: {
    id: 'Firmware.upload',
    defaultMessage: 'Upload',
  },
  selectAFile: {
    id: 'Firmware.selectAFile',
    defaultMessage: "Select a file you'd like to upload",
  },
  uploadFile: {
    id: 'Firmware.uploadFile',
    defaultMessage: 'Upload file',
  },
  dropFileHere: {
    id: 'Firmware.dropFileHere',
    defaultMessage: 'Drop your file here or',
  },
  chooseFile: {
    id: 'Firmware.chooseFile',
    defaultMessage: 'choose a file',
  },
  onlyBinFiles: {
    id: 'Firmware.onlyBinFiles',
    defaultMessage: 'Only bin files are allowed',
  },
  fieldIsRequired: {
    id: 'Firmware.fieldIsRequired',
    defaultMessage: 'This field is required',
  },
  create: {
    id: 'Firmware.create',
    defaultMessage: 'Create',
  },
  email: {
    id: 'Firmware.email',
    defaultMessage: 'Email',
  },
  emailPlaceholder: {
    id: 'Firmware.emailPlaceholder',
    defaultMessage: 'Add Placeholder',
  },
  organizationForCustomSoftware: {
    id: 'Firmware.organizationForCustomSoftware',
    defaultMessage: 'Organization for Custom Software',
  },
  organizations: {
    id: 'Firmware.organizations',
    defaultMessage: 'Organizations',
  },
  organization: {
    id: 'Firmware.organization',
    defaultMessage: 'Organization',
  },
  addOrganizations: {
    id: 'Firmware.addOrganizations',
    defaultMessage: 'Add Organizations',
  },
  betaUsers: {
    id: 'Firmware.betaUsers',
    defaultMessage: 'Users for beta firmware (select via email):',
  },
  userEmails: {
    id: 'Firmware.userEmails',
    defaultMessage: 'User Emails',
  },
  addUserEmail: {
    id: 'Firmware.addUserEmail',
    defaultMessage: 'Add User Email',
  },
  emailAddressCount: {
    id: 'Firmware.emailAddressCount',
    defaultMessage: 'Email Address {number}',
  },
  organizationCount: {
    id: 'Firmware.organizationCount',
    defaultMessage: 'Organization {number}',
  },
  fieldTest: {
    id: 'Firmware.fieldTest',
    defaultMessage: 'Field Test',
  },
  global: {
    id: 'Firmware.global',
    defaultMessage: 'Global',
  },
  dev: {
    id: 'Firmware.dev',
    defaultMessage: 'Dev',
  },
  custom: {
    id: 'Firmware.custom',
    defaultMessage: 'Custom',
  },
  beta: {
    id: 'Firmware.beta',
    defaultMessage: 'Beta',
  },
  archived: {
    id: 'Firmware.archive',
    defaultMessage: 'Archived',
  },
  version: {
    id: 'Firmware.version',
    defaultMessage: 'Version',
  },
  id: {
    id: 'Firmware.id',
    defaultMessage: 'Id',
  },
  type: {
    id: 'Firmware.type',
    defaultMessage: 'Type',
  },
  tier: {
    id: 'Firmware.tier',
    defaultMessage: 'Tier',
    description: 'Describes a tier of firmware',
  },
  file: {
    id: 'Firmware.file',
    defaultMessage: 'File',
  },
  deleteFirmwareDescription: {
    id: 'Firmware.deleteFirmwareDescription',
    defaultMessage: "Are you sure you'd like to delete this firmware? This action cannot be undone",
  },
  deleteFirmwareTitle: {
    id: 'Firmware.deleteFirmwareTitle',
    defaultMessage: 'Delete Firmware',
  },
  deleteFirmwareButtonText: {
    id: 'Firmware.deleteFirmwareButtonText',
    defaultMessage: 'Delete Firmware',
  },
  firmwareDeletionSuccessful: {
    id: 'Firmware.firmwareDeletionSuccessful',
    defaultMessage: 'Firmware deleted successfully',
  },
  firmwareCreationSuccessful: {
    id: 'Firmware.firmwareCreationSuccessful',
    defaultMessage: 'Firmware created successfully',
  },
  firmwareUpdateSuccessful: {
    id: 'Firmware.firmwareUpdateSuccessful',
    defaultMessage: 'Firmware updated successfully',
  },
  firmwareCreationFailure: {
    id: 'Firmware.firmwareCreationFailure',
    defaultMessage: 'Firmware not created successfully',
  },
  unknown: {
    id: 'Firmware.unknown',
    defaultMessage: 'Unknown',
  },
  true: {
    id: 'Firmware.true',
    defaultMessage: 'True',
  },
  false: {
    id: 'Firmware.false',
    defaultMessage: 'False',
  },
  update: {
    id: 'Firmware.update',
    defaultMessage: 'Update',
  },
  firmwareTier: {
    id: 'Firmware.firmwareTier',
    defaultMessage: 'Firmware Tier',
  },
  firmwareFreeLabel: {
    id: 'Firmware.firmwareFreeLabel',
    defaultMessage: 'Free',
  },
  firmwareTierPlaceholder: {
    id: 'Firmware.firmwareTierPlaceholder',
    defaultMessage: 'Add a tier...',
  },
  paid: {
    id: 'Firmware.paid',
    defaultMessage: 'Paid',
  },
  active: {
    id: 'Firmware.active',
    defaultMessage: 'Active',
  },
  status: {
    id: 'Firmware.status',
    defaultMessage: 'Status',
  },
  noFirmwaresMatchSearch: {
    defaultMessage: 'Sorry, no Firmware matches your search.',
    id: 'Firmware.noFirmwaresMatchSearch',
    description: 'Message provided when no firmwares match a search criteria',
  },
  firmwareUsersLabel: {
    defaultMessage: 'Assigned Users',
    id: 'Firmware.firmwareUsersLabel',
  },
  firmwareOrganizationsLabel: {
    defaultMessage: 'Assigned Organizations',
    id: 'Firmware.firmwareOrganizationsLabel',
  },
  firmwareOrgPlaceholder: {
    defaultMessage: 'Select an Organization',
    id: 'Firmware.firmwareOrgPlaceholder',
  },
});
